module.exports = __webpack_public_path__ + "media/demo/social_seo_page-da2061df.jpg";